import React, { useCallback, useEffect, useState } from "react";
import { api } from "../api";
import type { Contact } from "../types";
import { useDrawer } from "../context/DrawerContext";
import LeadForm from "../components/LeadForm";

export default function Leads() {
  const { open } = useDrawer();
  const [query, setQuery] = useState("");
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  const search = useCallback(async (q: string) => {
    setLoading(true);
    try {
      const res = await api.searchContacts(q);
      setContacts(res);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    search("");
  }, [search]);

  useEffect(() => {
    const t = setTimeout(() => search(query), 300);
    return () => clearTimeout(t);
  }, [query, search]);

  return (
    <div className="leads-page">
      <div className="kanban-header">
        <h1>Leads / Pacientes</h1>
        <button className="btn-primary" onClick={() => setShowForm(true)}>
          + Nuevo lead
        </button>
      </div>

      <input
        className="search"
        style={{ width: "100%", marginBottom: 16 }}
        placeholder="Buscar por nombre, teléfono o email..."
        value={query}
        onChange={(e: any) => setQuery(e.target.value)}
      />

      {loading && <div className="loading-strip">Buscando...</div>}

      <div className="contact-list">
        {contacts.map((c) => (
          <div key={c.id} className="contact-row" onClick={() => open(c.id)}>
            <div className="name">{c.full_name}</div>
            <div className="meta">
              {c.phone} {c.email ? `· ${c.email}` : ""}
            </div>
          </div>
        ))}
        {!loading && contacts.length === 0 && <p className="meta">Sin resultados.</p>}
      </div>

      {showForm && (
        <LeadForm
          onClose={() => setShowForm(false)}
          onCreated={() => search(query)}
        />
      )}
    </div>
  );
}
